import Box from "@mui/material/Box";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../common/ErrorFallback";
import { Dashboard } from "./Dashboard";
import { Route, Routes } from "react-router";

export function ReportingContainer() {
  return (
    <Box
      data-testid="reporting-container"
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
        </Routes>
      </ErrorBoundary>
    </Box>
  );
}
